module.exports = __webpack_public_path__ + "d421e57a9c83c90cc2951bbadffecc5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000V41.png
// module id = 1444
// module chunks = 0